import React, { useRef, useState, useEffect } from "react";

/**
 * @param {number} speed        - 滚动速度 px/s，默认 40
 * @param {number} pauseDuration - 两端停留时间（秒），默认 1.5
 */
function SmartMarquee({ children, speed = 40, pauseDuration = 1.5, style }) {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [overflow, setOverflow] = useState(0);
  // 每个实例生成唯一动画名，避免多个组件互相干扰
  const animName = useRef(`marquee_${Math.random().toString(36).slice(2)}`).current;

  useEffect(() => {
    const container = containerRef.current;
    const text = textRef.current;
    if (!container || !text) return;

    const check = () => {
      const diff = text.scrollWidth - container.clientWidth;
      setOverflow(Math.max(0, diff));
    };

    check();
    const observer = new ResizeObserver(check);
    observer.observe(container);
    return () => observer.disconnect();
  }, [children]);

  const shouldScroll = overflow > 0;

  // 各阶段时间
  const moveDuration = overflow / speed;           // 单程移动时长
  const total = moveDuration * 2 + pauseDuration * 2; // 完整一轮时长

  // 各关键帧百分比
  const p1 = (moveDuration / total) * 100;                           // 到达右端
  const p2 = ((moveDuration + pauseDuration) / total) * 100;        // 右端停留结束
  const p3 = ((moveDuration * 2 + pauseDuration) / total) * 100;    // 回到左端
  // p4 = 100%  左端停留结束（下一轮开始）

  return (
    <div
      ref={containerRef}
      style={{ overflow: "hidden", whiteSpace: "nowrap", width: "100%", ...style }}
    >
      {shouldScroll && (
        <style>{`
          @keyframes ${animName} {
            0%       { transform: translateX(0);          animation-timing-function: ease-in-out; }
            ${p1}%   { transform: translateX(-${overflow}px); animation-timing-function: linear; }
            ${p2}%   { transform: translateX(-${overflow}px); animation-timing-function: ease-in-out; }
            ${p3}%   { transform: translateX(0);          animation-timing-function: linear; }
            100%     { transform: translateX(0); }
          }
        `}</style>
      )}
      <span
        ref={textRef}
        style={{
          display: "inline-block",
          animation: shouldScroll
            ? `${animName} ${total}s linear infinite`
            : "none",
        }}
      >
        {children}
      </span>
    </div>
  );
}

export default SmartMarquee;